export default __webpack_public_path__ + "static/03-0c475e7f0256ba9e3dd3228ac6690e58.jpg";